var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards"},_vm._l((_vm.cards),function(card,i){return _c('Card',{key:i,attrs:{"component":card.component,"options":card.options}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }